export enum CancellationTypeEnum {
    Web = 0,
    OnCall = 1,
    Visit = 2,
    None = 3
  }
  